import { useRecoilState } from "recoil";
import { metadadoState } from "../atom";

const useMetadadoState = () => {
    return useRecoilState(metadadoState);
};

export default useMetadadoState;